import {RestResource} from '../../rest'
import {COMMON_SERVER,BILLING_SERVER,PERSON_SERVER} from '../../server'
import {athubAxios} from '../../../util'
import axios from 'axios';




//查询对应的数据中心报表历史数据
function querySysRoomReportInfoOld(queryString){
    var userAuthInfo = {
        "token": localStorage.getItem("token"),
        "appId": localStorage.getItem("appId"),
        "authorg": localStorage.getItem("authorg"),
        "authsites": localStorage.getItem("authsites"),
        "defsite": localStorage.getItem("defsite"),
        "realname": "billing-219-oam",
        "userId": localStorage.getItem("userid"),
        "userName": localStorage.getItem("username"),
        "authScope": {
            "userId": localStorage.getItem("userid"),
            "sites": localStorage.getItem("authsites"),
            "orgs": localStorage.getItem("authorg")
        },
        "authorizes": ["billing.ui.RBSC.WO.RSC", "billing.be.RBSC.WO.new", "billing.be.RBSC.WO.RSC", "billing.ui.RBSC.WO.save", "billing.ui.RBSC.WO.view", "billing.ui.RBSC.WO.commit", "billing.ui.RBSC.WO.new", "menu.billing3", "billing.be.RBSC.WO.viewAll", "billing.ui.RBSC.viewAllCustomer", "billing.be.RBSC.viewAllCustomer"]
    };
    var userAuthInfoString = JSON.stringify( userAuthInfo );
    var userAuthInfoStringURIencoded = encodeURIComponent( userAuthInfoString );
    return new Promise((resolve, reject) => {
        axios.get(`${BILLING_SERVER}/billingReport/WO/rack?queryString=`+queryString, {
            params: {},
            headers: { 'User-Auth-Info':userAuthInfoStringURIencoded},
        }).then((responseBody) => {
            if (responseBody.status == 200) {
            resolve(responseBody.data.data);
            }

    }).catch(error => {
        reject(error);
    });
    });
}


//查询对应的数据中心报表实时数据
function querySysRoomReportInfoNew(queryString){

    var userAuthInfo = {
        "token": localStorage.getItem("token"),
        "appId": localStorage.getItem("appId"),
        "authorg": localStorage.getItem("authorg"),
        "authsites": localStorage.getItem("authsites"),
        "defsite": localStorage.getItem("defsite"),
        "realname": "billing-219-oam",
        "userId": localStorage.getItem("userid"),
        "userName": localStorage.getItem("username"),
        "authScope": {
            "userId": localStorage.getItem("userid"),
            "sites": localStorage.getItem("authsites"),
            "orgs": localStorage.getItem("authorg")
        },
        "authorizes": ["billing.ui.RBSC.WO.RSC", "billing.be.RBSC.WO.new", "billing.be.RBSC.WO.RSC", "billing.ui.RBSC.WO.save", "billing.ui.RBSC.WO.view", "billing.ui.RBSC.WO.commit", "billing.ui.RBSC.WO.new", "menu.billing3", "billing.be.RBSC.WO.viewAll", "billing.ui.RBSC.viewAllCustomer", "billing.be.RBSC.viewAllCustomer"]
    };
    var userAuthInfoString = JSON.stringify( userAuthInfo );
    var userAuthInfoStringURIencoded = encodeURIComponent( userAuthInfoString );


    return new Promise((resolve, reject) => {
        axios.get(`${BILLING_SERVER}/billingReport/WO/rack/realtime?queryString=`+queryString, {
        params: {},
        headers: { 'User-Auth-Info':userAuthInfoStringURIencoded},
        }).then((responseBody) => {
        if (responseBody.status == 200) {
            resolve(responseBody.data.data);
        }
        }).catch(error => {
            reject(error);
        });
        });
}


//根据部门查询对应的数据中心
function queryDcnumByDepts(array){

    return new Promise((resolve, reject) => {
            axios.get(`${COMMON_SERVER}/sys/room/getRoomsByDepts?deptIds=`+array, {
            'deptIds':array
        }).then((responseBody) => {
            if (responseBody.status == 200) {
        resolve(responseBody.data.data);
    }
    }).catch(error => {
            reject(error);
    });
    });
}


//根据机构级联地点
function fetchSiteList(params) {
    return new Promise((resolve, reject) => {
        axios.post(`${PERSON_SERVER}/site/page`,
            params
        ).then((responseBody) => {
            if (responseBody.status == 200) {
        resolve(responseBody.data.data);
    }
    }).catch(error => {
            reject(error);
    });
    });
}


export {
    querySysRoomReportInfoOld,
    querySysRoomReportInfoNew,
    queryDcnumByDepts,
    fetchSiteList
  
}
